import { REGISTRATION_CODES } from "./RegistrationCodes"

//Notes on registration parsing
//MC = motor carrier
//IR = registrant
//RW = registered weight
export const registrationParser = (str) => {
  if (!str) return;
  if (str.slice(0, 4) === "@\rAA") {
    //add two additional \r before the AA to account for the missing \r
    str = str.slice(0, 2) + "\r\r" + str.slice(2)
  }
  const complianceIndicator = str.charAt(0)
  const dataElementSeparator = str.charAt(1)

  // Not currently used but may be useful in the future
  // const recordSeparator = str.charAt(2)
  // const segmentTerminator = str.charAt(3)

  const fileType = str.slice(4, 9)

  // Not currently used but may be useful in the future
  // const jurisdictionCode = str.slice(9, 15)
  // const versionNumber = str.slice(15, 17)

  //if numSubFileEntries is 03 there is an RW entry, if it is 02 there is not
  const numSubFileEntries = str.slice(17, 19)


  const mcDesignator = str.slice(19, 21)
  const mcOffset = str.slice(21, 25)
  const mcFileLength = str.slice(25, 29)


  const irDesignator = str.slice(29, 31)
  const irOffset = str.slice(31, 35)
  const irFileLength = str.slice(35, 39)

  const mcEntry = str.slice(+mcOffset, +mcOffset + (+mcFileLength))
  const irEntry = str.slice(+irOffset, +irOffset + (+irFileLength))

  let rwDesignator = null;
  let rwOffset = null;
  let rwFileLength = null;
  let rwEntry = null;

  if (numSubFileEntries === "03") {
    rwDesignator = str.slice(39, 41)
    rwOffset = str.slice(41, 45)
    rwFileLength = str.slice(45, 49)
    rwEntry = str.slice(+rwOffset, +rwOffset + (+rwFileLength))
  }

  if (complianceIndicator !== '@') {
    console.error('Incorrect Compliance Indicator. Please clear the field and try scanning the barcode again.')
    return;
  }

  if (fileType !== "AAMVA") {
    console.error('Incorrect File Type. This document is not a AAMVA registration.')
    return;
  }

  const mcObj = parseEntryToObject(mcEntry, mcDesignator, dataElementSeparator)
  const irObj = parseEntryToObject(irEntry, irDesignator, dataElementSeparator)
  const rwObj = rwEntry ? parseEntryToObject(rwEntry, rwDesignator, dataElementSeparator) : null
  return { MC: mcObj, IR: irObj, RW: rwObj }
  // return rwObj
}

function cleanupValue(str) {
  //strips trailing commas and whitespace
  return str?.replace(/[, ]+$/, "")?.trim() || str
}

function parseEntryToObject(entry, designator, dataElementSeparator) {
  //first check that the mcEntry begins with MC and has the dataElementSeparator as the third character and the final character is /r
  if (entry.slice(0, 2) !== designator || entry.charAt(2) !== dataElementSeparator || entry.slice(-1) !== "\r") {
    console.error(`Error parsing ${designator} entry`)
    return;
  }

  //remove the file designator and the final character
  entry = entry.slice(3, -1)

  const arr = entry.split(dataElementSeparator)
  //for each value in the mcArr array, check if the first three characters are a valid code in REGISTRATION_CODES. Then add the value to the mcObj with the value of REGISTRATION_CODES[code] as the key and the remaining characters as the value
  let obj = {}
  arr.forEach(i => {
    let code = i.slice(0, 3)
    let value = cleanupValue(i.slice(3))
    let name = REGISTRATION_CODES[designator] ? REGISTRATION_CODES[designator][code] : code
    obj[name] = value
    if (name === "modelYear") {
      //check if the model year is in the format YY and convert it to YYYY
      //if YY format, check if the year is greater than the current year + 1, if so add 1900, otherwise add 2000
      if (value.length === 2) {
        let year = +value
        let currentYear = new Date().getFullYear()
        obj[name] = (2000 + year) > currentYear + 1 ? `19${value}` : `20${value}`
      }
    }
  })
  return obj;
}
